import React from "react";
import { formatDate, getBadgeColor } from "../../../helper/Helper";
import { Link } from "react-router-dom";

const DealOfTheDayRow = React.memo(
  ({ item, index, page, limit, onStatusChange, onDelete }) => {
    console.log(item);

    const isActive = item.status === "active";

    return (
      <tr>
        <td>{(page - 1) * limit + index + 1}.</td>

        <td>
          <p className="fw-medium">
            {item?.productId?.title}{" "}
            {item?.variantId?.variant_name &&
              ` - ${item.variantId.variant_name}`}
          </p>
        </td>
        <td>
          <p className="fw-medium">{formatDate(item.dealDate, "D MMM YYYY")}</p>
        </td>
        <td>
          <span className={`badge bg-${getBadgeColor(item.status)}`}>
            {item.status?.toUpperCase()}
          </span>
        </td>
        <td>₹{item.originalPrice}</td>
        <td>₹{item.dealPrice}</td>
        <td>
          {item.discountType === "PERCENTAGE"
            ? `${item.discountValue}%`
            : `₹${item.discountValue}`}
        </td>
        <td>{formatDate(item.createdAt)}</td>
        <td className="action-table-data">
          <div className="edit-delete-action">
            <Link
              to={`/deal-of-the-day/edit/${item._id}`}
              className="me-2 p-2"
              state={{ id: item._id }}
            >
              <i className="ti ti-pencil" />
            </Link>

            <a
              className="p-2"
              href="javascript:void(0);"
              data-bs-toggle="modal"
              data-bs-target="#delete-modal"
              onClick={(e) => {
                onDelete(item._id);
              }}
            >
              <i className="ti ti-trash" />
            </a>
          </div>
        </td>
      </tr>
    );
  },
);

export default DealOfTheDayRow;
